// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"6aa8f625","138":"ca01007a","845":"abd5baca","888":"cb7ca911"}[chunkId] + ".chunk.js";
};